import { AbstractControl, FormGroup } from '@angular/forms';

interface CompanyValue {
  CompanyNumber?: unknown;
  Company?: unknown;
  Id?: unknown;
}

function asCompanyId(raw: unknown): number | null {
  const id = typeof raw === 'string' ? Number(raw.trim() || NaN) : raw;
  return typeof id === 'number' && Number.isInteger(id) && id > 0 ? id : null;
}

/**
 * US 36258: the Viewpoint company id held by the control named in `options.favoriteCompanyFormControl`,
 * or null when the option is off or that control is empty. The control may hold the company record
 * (typeahead-company, `CompanyNumber`) or the bare number, as a saved or pushed value does.
 */
export function dynamicFavoriteCompanyId(
  group: FormGroup | null | undefined,
  controlName: string | null | undefined
): number | null {
  const control: AbstractControl | undefined = controlName
    ? group?.controls?.[controlName]
    : undefined;
  const value = control?.value as unknown;
  if (value && typeof value === 'object') {
    const record = value as CompanyValue;
    return asCompanyId(record.CompanyNumber ?? record.Company ?? record.Id);
  }
  return asCompanyId(value);
}

/** A search row the API flagged as one of the company's recommended contacts (either casing). */
export function dynamicIsRecommended(item: unknown): boolean {
  const row = item as { IsRecommended?: boolean; isRecommended?: boolean };
  return !!(row?.IsRecommended ?? row?.isRecommended);
}

/** The search results flagged recommended. */
export function dynamicRecommended(data: unknown): Array<unknown> {
  return Array.isArray(data) ? data.filter(dynamicIsRecommended) : [];
}
